export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7628.e39dd2f6.jpg";